import {
  ChecklistDTO,
  PositionDTO,
  WizardDTO,
  SurveyDTO,
  FormDTO,
  DomainListDTO,
  IdentificationStartDTO,
  LabelListDTO,
  UserDataDTO,
  WizardStepNextOutputDTO,
  IdentificationVerifyDTO,
  QuotationDTO,
  BankAccountLinkDTO,
  BankAccountEvaluationDTO,
  NoteDTO,
  UserCustomerDTO,
  AtcDTO,
  NotificationDTO,
  CreditRequestDTO,
  QuotationBoundariesDTO,
  CreditUseListDTO,
  TaskListDTO,
  PositionCreateDTO,
  Api,
  CustomerDTO,
  ReportDTO,
  HandoverStartDTO,
  HandoverStatusDTO,
  ChannelDTO,
  CardDTO,
  ResumeInspectDTO,
  ResumeContactsCheckDTO,
  FinalizeDTO,
  OcrCheckDTO,
  OcrScanDTO,
  DigitalSignStartDTO,
  DigitalSignVerifyDTO,
  IBMClientDTO,
  IBMLoginDTO,
  LoginOtpSendDTO,
  InfrastructureDataDTO
} from '../../models';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OutputAdapterService implements Api {
  putLog(output: any): any {
    return output;
  }

  getMobileStatus(output: any): InfrastructureDataDTO {
    return output;
  }

  getLabels(output: any): LabelListDTO {
    return output;
  }

  getDomain(output: any): DomainListDTO {
    return output;
  }

  postIBMClient(output: any): IBMClientDTO {
    return output;
  }

  postSetSignupCode(output: any): any {
    return output;
  }

  postRegister(output: any): any {
    return output;
  }

  postIBMToken(output: any): IBMLoginDTO {
    return output;
  }

  postLoginOtpSend(output: any): LoginOtpSendDTO {
    return output;
  }

  postLoginOtpVerify(output: any): any {
    return output;
  }

  postLogout(output: any): any {
    return output;
  }

  postResetPassword(output: any): any {
    return output;
  }

  postSecurityLogon(output: any): any {
    return output;
  }

  getSecurityVerify(output: any): void {
    return output;
  }

  getSecurityUserData(output: any): UserDataDTO {
    return output;
  }

  getOnboardingCustomer(output: any): UserCustomerDTO {
    return output;
  }

  putOnboardingCustomer(output: any): any {
    return output;
  }

  getQuotationsBoundaries(output: any): QuotationBoundariesDTO {
    return output;
  }

  postQuotations(output: any): any {
    return output;
  }

  putPosition(output: any): PositionCreateDTO {
    return output;
  }

  postPositionSave(output: any): string {
    return output;
  }

  postPosition(output: any): PositionCreateDTO {
    return output;
  }

  getPersonalPositions(output: any): PositionDTO[] {
    return !output || !(output instanceof Array) ? [] : output;
  }

  getPersonalTasks(output: any): TaskListDTO {
    return output;
  }

  getPosition(output: any): PositionDTO {
    return output;
  }

  getPositionCustomer(output: any): CustomerDTO {
    return output;
  }

  getPositionQuotation(output: any): QuotationDTO {
    return output;
  }

  getPositionFull(output: any): PositionDTO {
    return output;
  }

  postPositionWithdraw(output: any): any {
    return output;
  }

  postPositionRelease(output: any): any {
    return output;
  }

  postPositionFinalize(output: any): FinalizeDTO {
    return output;
  }

  getPreWizard(output: any): WizardDTO {
    return output;
  }

  getWizard(output: any): WizardDTO {
    return output;
  }

  putWizardStepNext(output: any): WizardStepNextOutputDTO {
    return output;
  }

  putWizardStepOpen(output: any): WizardStepNextOutputDTO {
    return output;
  }

  putWorkflowTaskClose(output: any): WizardStepNextOutputDTO {
    return output;
  }

  getSurvey(output: any): SurveyDTO[] {
    return output;
  }

  putSurvey(output: any) {
    return output;
  }

  getForm(output: any): FormDTO[] {
    return output;
  }

  postForm(output: any): any {
    return output;
  }

  getChecklist(output: any): ChecklistDTO {
    return output;
  }

  getChecklistDocumentDownload(output: any): any {
    return output;
  }

  postChecklistDocumentUpload(output: any): number {
    return output;
  }

  putChecklistDocumentOverride(output: any): number {
    return output;
  }

  getChecklistDocumentScan(output: any): OcrScanDTO {
    return output;
  }

  getChecklistDocumentCheckOcr(output: any): OcrCheckDTO {
    return output;
  }

  getReports(output: any): ReportDTO[] {
    return output;
  }

  postReportModule(output: any): any {
    return output;
  }

  postReport(output: any): any {
    return output;
  }

  postIdentificationStart(output: any): IdentificationStartDTO {
    return output;
  }

  getIdentificationVerify(output: any): IdentificationVerifyDTO {
    return output;
  }

  postSignStart(output: any): DigitalSignStartDTO {
    return output;
  }

  getSignVerify(output: any): DigitalSignVerifyDTO {
    return output;
  }

  getSignResume(output: any): DigitalSignStartDTO {
    return output;
  }

  postPsd2Start(output: any): BankAccountLinkDTO {
    return output;
  }

  getPsd2Verify(output: any): BankAccountEvaluationDTO {
    return output;
  }

  getPositionQuotationBoundaries(output: any): QuotationBoundariesDTO {
    return output;
  }

  putPositionQuotation(output: any): void {
    return output;
  }

  putObligationConfirm(output: any): any {
    return output;
  }

  getNotes(output: any): NoteDTO[] {
    return output;
  }

  getAtc(output: any): AtcDTO[] {
    return output;
  }

  postAtc(output: any): any {
    return output;
  }

  postContactSendOtp(output: any): any {
    return output;
  }

  putContactVerifyOtp(output: any): any {
    return output;
  }

  postContactVerify(output: any): any {
    return output;
  }

  getNotifications(output: any): NotificationDTO[] {
    return output;
  }

  putNotification(output: any): void {
    return output;
  }

  getQuotationCreditRequest(output: any): CreditRequestDTO {
    return output;
  }

  getQuotationCreditUse(output: any): CreditUseListDTO {
    return output;
  }

  postPostselling(output: any): any {
    return output;
  }

  postHandover(output: any): HandoverStartDTO {
    return output;
  }

  getHandover(output: any): HandoverStatusDTO {
    return output;
  }

  getChannel(output: any): ChannelDTO {
    return output;
  }

  getCard(output: any): CardDTO {
    return output;
  }

  getResumePositionInspect(output: any): ResumeInspectDTO {
    return output;
  }

  postResumeContactsCheck(output: any): ResumeContactsCheckDTO {
    return output;
  }

  putResumeContactsCheck(output: any): any {
    return output;
  }

  protected cleanPayload<T>(res: any): T {
    if (!!res && !!res.payload) {
      return res.payload;
    } else {
      return res;
    }
  }
}
